import * as React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './theme';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import store from './redux/store'
import { Provider } from 'react-redux'
import { LicenseInfo } from '@mui/x-license';
import {KindeProvider} from "@kinde-oss/kinde-auth-react";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENCE_KEY);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <Provider store={store}>
                    <KindeProvider
                        clientId={process.env.REACT_APP_KINDE_CLIENT_ID}
                        domain={process.env.REACT_APP_KINDE_DOMAIN}
                        logoutUri={process.env.REACT_APP_KINDE_LOGOUT_URL}
                        redirectUri={process.env.REACT_APP_KINDE_POST_LOGIN_REDIRECT_URL}
                        audience={process.env.REACT_APP_KINDE_AUDIENCE}
                    >
                        <App />
                    </KindeProvider>
                </Provider>
            </BrowserRouter>
        </ThemeProvider>
);
